import styles from './Program.module.css';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SubPageTop from '../components/SubPageTop';
import Oneday from '../components/program/Oneday';
import Academy from '../components/program/Academy';

const TABS = [
    { label: "기업/기관교육", value: "oneday" },
    { label: "아카데미 교육", value: "academy" },
];

function Program() {
    const [searchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    
    // URL 파라미터가 있고 유효한 탭이면 그것을 초기값으로, 없으면 첫 번째 탭
    const initialTab = TABS.find(t => t.value === tabParam)?.value || TABS[0].value;
    const [tab, setTab] = useState(initialTab);
    
    const tabListRef = useRef(null);
    const tabRefs = useRef([]);
    const [underlineStyle] = useState({});

    // URL 파라미터가 변경될 때 탭 상태 업데이트
    useEffect(() => {
        if (tabParam && TABS.find(t => t.value === tabParam)) {
            setTab(tabParam);
        }
    }, [tabParam]);
/*     useEffect(() => {
        const idx = TABS.findIndex((t) => t.value === tab);
        if (idx !== -1 && tabRefs.current[idx]) {
            const el = tabRefs.current[idx];
            setUnderlineStyle({
                width: el.offsetWidth + "px",
                left: el.offsetLeft + "px",
                bottom: "0px",
                transition: "all 0.32s cubic-bezier(.4,0,.2,1)",
            });
        }
    }, [tab]);
 */

    return (
        <div className={styles.subWrap}>
            <SubPageTop title="Program" subTitle="프로그램" backgroundColor="#FDC983" />
            <div className={styles.programTabs}>
                <ul className={styles.tabList} ref={tabListRef}>
                    {TABS.map((t, i) => (
                        <li
                            ref={(el) => (tabRefs.current[i] = el)}
                            key={t.value}
                            className={`${styles.tabItem} ${
                                tab === t.value ? styles.active : ""
                            }`}
                            onClick={() => setTab(t.value)}
                        >
                            {t.label}
                        </li>
                    ))}
                    <div
                        className={styles.tabUnderline}
                        style={underlineStyle}
                    ></div>
                </ul>
                <div className={styles.tabContent}>
                    {tab === "oneday" && <Oneday />}
                    {tab === "academy" && <Academy />}
                </div>
            </div>
        </div>
    );
}

export default Program; 